//
//
//
//
//
//

export default {
  name: "ContainedButton",
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
}
